import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import client from '../../api/client';

const STATUS_COLOR_CELL = {
  'Working Fine': 'text-green-700 bg-green-50',
  'Minor Issue - Resolved': 'text-amber-700 bg-amber-50',
  'Requires Follow-up': 'text-orange-700 bg-orange-50',
  'Not Working': 'text-red-700 bg-red-50',
  'Replaced': 'text-blue-700 bg-blue-50',
  'N/A': 'text-gray-500 bg-gray-50',
};

export default function BHELPMReportView() {
  const { ticketId } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    client.get(`/bhel/pm-report/${ticketId}/`).then(r => setData(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, [ticketId]);

  if (loading) return <div className="p-8 text-center text-gray-400">Loading report…</div>;
  if (!data) return <div className="p-8 text-center text-red-400">Report not available.</div>;

  return (
    <div className="p-6 space-y-4">
      <button onClick={() => navigate(-1)} className="text-blue-600 hover:text-blue-800 text-sm flex items-center gap-1">
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7"/></svg>
        Back
      </button>
      <h1 className="text-xl font-bold text-gray-900">PM Report</h1>

      {data.summary && (
        <div className="bg-blue-50 border border-blue-100 rounded-2xl p-4">
          <p className="text-sm text-blue-800">{data.summary}</p>
        </div>
      )}

      {data.rows?.length > 0 ? (
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-gray-50 text-xs font-semibold text-gray-400 uppercase tracking-wider">
                  {data.headers.map((h, i) => <th key={i} className="px-4 py-3 text-left">{h}</th>)}
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50">
                {data.rows.map((row, i) => (
                  <tr key={i}>
                    {data.headers.map((h, j) => (
                      <td key={j} className="px-4 py-3">
                        {h === 'PM STATUS' ? (
                          <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${STATUS_COLOR_CELL[row[h]] || 'text-gray-600 bg-gray-100'}`}>{row[h]}</span>
                        ) : (
                          <span className="text-gray-700">{row[h]}</span>
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <div className="p-8 text-center text-gray-400">No data rows found in report.</div>
      )}
    </div>
  );
}
